import { NgModule } from '@angular/core';
import { PartiesRoutingModule } from './parties-routing.module';
import { PartiesComponent } from './parties.component';
import { PartiesGridComponent } from './parties-grid/parties-grid.component';
import { ParticipantTableComponent } from './participant-table/participant-table.component';
import { SharedModule } from '@fsx/fsx-shared';
import { FsxUiComponentsModule } from '@fsx/ui-components';
import { RepresentationGridComponent } from './representation-grid/representation-grid.component';
import { RepresentationGridItemComponent } from './representation-grid-item/representation-grid-item.component';
import { ValidationModule } from '../validation/validation.module';
import { ContactsModule } from '../contacts/contacts.module';
import { PartyIsValid } from './parties-grid/parties-grid-model-validation.pipe';
import { SubfPartiesGridComponent } from '../parties/subf-parties-grid/subf-parties-grid.component';
import { PartiesGridDetailComponent } from '../parties/parties-grid-detail/parties-grid-detail.component';

@NgModule({
  declarations: [
    PartiesComponent,
    PartiesGridComponent,
    ParticipantTableComponent,
    RepresentationGridComponent,
    RepresentationGridItemComponent,
    PartyIsValid,
    SubfPartiesGridComponent,
    PartiesGridDetailComponent,
  ],
  imports: [
    SharedModule,
    FsxUiComponentsModule,
    PartiesRoutingModule,
    ContactsModule,
    ValidationModule,
  ],
  exports: [PartiesComponent, ParticipantTableComponent],
})
export class PartiesModule {}
